// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"53":"fbbecf5b","581":"b307c898","628":"b307c898","994":"e3d7e332"}[chunkId] + ".css";
};